<template>
	<svg width="200" height="100" viewBox="0 0 200 100" class="preview-svg">
		<rect width="200" height="100" fill="white"></rect>
		<path d="M 20 80 L 180 80" stroke="#ccc" stroke-width="1"></path>
		<path d="M 20 20 L 20 80" stroke="#ccc" stroke-width="1"></path>
		<path
			d="M 76.632 70.749 C 89.268 70.749 108.067 50.442 118.576 43.983 C 141.334 29.997 152.636 21 180 21 L 179.98 19.528 C 139.98 19.528 59.887 20.429 19.887 20.429 L 20.769 70.617 L 76.632 70.749 Z"
			fill="#8dc533"
			opacity="0.2"
		></path>
		<path
			d="M 96.321 79.88 C 107.813 79.88 156.189 34.64 180.054 34.64 L 180 80 L 124.635 80.112 L 96.321 79.88 Z"
			fill="#ff4444"
			opacity="0.2"
		></path>
		<path
			d="M 20.098 79.226 C 23.452 79.226 56.742 79.751 81.327 78.585 C 92.392 78.06 109.343 60.825 128.604 48.842 C 139.057 42.339 149.325 34.973 158.448 31.087 C 168.724 26.71 177.343 26.006 179.91 26.006"
			stroke="#333"
			stroke-width="2"
			fill="none"
		></path>
	</svg>
</template>
